(function () {
    'use strict';

    angular.module('app').controller('AccountsController', AccountsController);

    AccountsController.$inject = [
        '$rootScope',
        '$scope',
        '$filter',
        '$timeout',
        '$q',
        '$routeParams',
        '$uibModal',
        '$location',
        'BusinessService',
        'SelectService',
        'ExportService',
        'LANGS',
        'blockUI',
        'NotifyService',
        'GoodsService',
        'CustomerService',
        'SettingsService',
        'POSService',
        'EmbeddedService',
        'TransactionService'
    ];

    function AccountsController(
        $rootScope,
        $scope,
        $filter,
        $timeout,
        $q,
        $routeParams,
        $uibModal,
        $location,
        BusinessService,
        SelectService,
        ExportService,
        LANGS,
        blockUI,
        NotifyService,
        GoodsService,
        CustomerService,
        SettingsService,
        POSService,
        EmbeddedService,
        TransactionService
    ) {

        $scope.model = {
            headerExist: false
        };

        $scope.importParams = {
            customers: {
                page: 1, count: 20
            }
        };

        $scope.data = {
            customers: null,
            total_customers_count: null,
            primary_id_type_list: [{value: 'phone', title: 'TEXT_PRIMARY_ID_TYPE_PHONE'}, {
                value: 'email',
                title: 'TEXT_PRIMARY_ID_TYPE_EMAIL'
            }]
        };

        $scope.state = {
            currentTab: 'general'
        };

        $scope.dataImport = {
            moment_format_parse_list: [false, 'DD.MM.YYYYY', 'MM.DD.YYYYY', 'DD/MM/YYYY', 'MM/DD/YYYY'],
            moment_format_parse_expire_date: false,
            fields: [{id: 'none', title: 'Do not import'}, {
                id: 'phone',
                group: 'general',
                title: 'Customer number'
            }, {id: 'email', group: 'general', title: 'Customer email'}, {
                id: 'user_name',
                group: 'general',
                title: 'Customer name'
            }, {id: 'user_birth_date', group: 'general', title: 'Birthday'}, {
                id: 'user_gender',
                group: 'general',
                title: 'Gender'
            }, {id: 'customer_additional_cards', group: 'general', title: 'Additional cards'}, {
                id: 'amount',
                group: 'limits',
                title: 'Pay on Account'
            }, {id: 'credit_type', group: 'limits', title: 'Credit type of account'}, {
                id: 'day_limit',
                group: 'limits',
                title: 'Day limit'
            }, {id: 'month_limit', group: 'limits', title: 'Month limit'}, {
                id: 'credit_limit',
                group: 'limits',
                title: 'Credit limit'
            }, {id: 'odometer', title: 'Odometer'}, {
                id: 'pos',
                title: 'TEXT__TITTLE_ONLINE_STORE_TABLE'
            }, {id: 'goods_items', title: 'The list of goods codes'}, {
                id: 'security_code',
                title: 'SpecialAccountsEdit#security_code'
            }],
            headers: [],
            imported: null,
            processed: null,
            primary_id_type: 'phone',
            pagerLengths: [10, 20, 50, 100, 200],
            summary: {
                total_rows_count: 0
            }
        };

        $scope.status = {
            file_type: null, import_progress: 0, chunk_size: 100, current_chunk: 0, result: {
                data: {
                    fields: null, rows: []
                }, add: 0, warning: 0, error: 0, errors: [], warnings: []
            }
        };

        $scope.error = {
            message: null
        };

        $scope.params = {
            user_id_value: null,
            user_id_type: null,
            page: 1,
            count: 10,
            account_extended: 'all',
            account_credit_type: 'all',
        };

        $scope.pager_count = [10, 20, 50, 100, 200];
        $scope.getPages = getTotalPaginatedPages;
        $rootScope.REQUEST_ABORT_PENDING = false;

        $scope.userIdTypes = [
            {id: 'phone', title: 'Mobile phone number'},
            {id: 'email', title: 'Email'},
            {id: 'id', title: 'Id'},
            {id: 'external-id', title: 'External id'}
        ];

        $scope.extendedTypes = [
            {value: 'all', title: 'All Extended types'},
            {value: 'yes', title: 'Extended'},
            {value: 'no', title: 'Not extended'}
        ];

        $scope.accountCreditTypes = [
            {value: 'all', title: 'All credit types'},
            {value: 'debit', title: 'credit_type_debit'},
            {value: 'credit', title: 'credit_type_credit'},
            {value: 'credit-unlimited', title: 'credit_type_credit-unlimited'}
        ];

        $scope.table_cols = [
            {
                visible: true,
                data: [
                    {value: 'user_phone', text: 'Customer number', visible: true},
                    {
                        value: 'user_email',
                        text: 'Customer email',
                        visible: true
                    },
                    {value: 'user_external_id', text: 'External id', visible: true},
                    {value: 'edit_user', text: 'Edit customer', visible: true, not_sortable: true, no_export: true},
                ]
            },
            {
                visible: true,
                data: [{value: 'user_name', text: 'Customer name', visible: true}, {
                    value: 'user_gender',
                    text: 'Gender',
                    visible: true
                },
                    {value: 'user_birth_date', text: 'Birthday', visible: true}]
            },
            {
                visible: true, data: [{value: 'customer_additional_cards', text: 'Additional cards', visible: true}]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'amount',
                        text: 'Corporate customer special account balance',
                        visible: true
                    },
                    {value: 'balance', text: 'Balance:', visible: true}]
            },
            {
                visible: true, data: [{value: 'credit_type', text: 'Credit type of account', visible: true}]
            },

            {
                visible: true,
                data: [{value: 'day_limit', text: 'Day limit', visible: true}, {
                    value: 'month_limit',
                    text: 'Month limit',
                    visible: true
                }, {value: 'credit_limit', text: 'Credit limit', visible: true}]
            },
            {
                visible: true, data: [{value: 'odometer', text: 'Odometer', visible: true}]
            },
            {
                visible: true, data: [{value: 'pos', text: 'TEXT__TITTLE_ONLINE_STORE_TABLE', visible: true}]
            },
            {
                visible: true, data: [{value: 'goods_items', text: 'The list of goods codes', visible: true}]
            },
            {
                visible: true,
                data: [{value: 'security_code', text: 'SpecialAccountsEdit#security_code', visible: true}]
            }
        ];

        $scope.getCurrenciesList = getCurrenciesList;
        $scope.multilang = MultilanguageHelper();
        $scope.getFiltersList = SelectService.getLList;

        $scope._importPageMode = 'default';

        // Declare depends functions
        $scope.isPageMode = isPageMode;
        $scope.isImportPageMode = isImportPageMode;

        var block_accounts_list = blockUI.instances.get('accounts_list'),
            block_customers_list = blockUI.instances.get('customers_list'),
            block_account_edit = blockUI.instances.get('account_edit'),
            block_import_customers = blockUI.instances.get('import_customers');

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        SettingsService.GetPlatformParams(function (success, response) {

            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {
                    $scope.data.primary_id_type_list.push({
                        value: 'external-id', title: 'External id'
                    });
                    $scope.dataImport.fields.push({
                        id: 'external_id', title: 'External id', group: 'general'
                    });

                }
            }
            initController();
        });

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        function isImportPageMode(mode) {
            return mode == $scope._importPageMode;
        }

        /**
         * Check parameter 'mode' in route ../client-accounts/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('account_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';
        }

        /**
         * Initialize controller
         */
        function initController() {
            $scope.multilang.initLangs(LANGS, $rootScope.LANG);

            initPageMode();
            // getCustomerFields();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;

                case 'show':
                    doShow();
                    break;

                case 'edit':
                    doEdit();
                    break;
            }
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        /**
         * Prepare data for display page in mode 'show'
         */
        function doShow() {
            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.special_accounts_processing) {
                        getSpecialAccounts();
                        $rootScope.TARIFF_LIMITATION.special_accounts_processing = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.special_accounts_processing = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function getSpecialAccounts() {
            block_accounts_list.start();
            BusinessService.SpecialAccounts(function (success, data) {
                if (success) {
                    $scope.data.accountsList = $rootScope.ACCOUNTS;
                }
                block_accounts_list.stop();
            });
        }

        /**
         * Specified Account active state
         * @param news: News object
         */
        $scope.itemActive = function (account) {
            return account.active == 1;
        };

        /**
         * Click on 'Make news' button
         */
        $scope.onMakeAccountClick = function () {
            $location.path('/client-accounts/create');
        };

        /**
         * Account enable/disable click
         */
        $scope.onAccountToggleClick = function (account) {
            block_accounts_list.start();
            var post_data = {
                id: account.id, active: account.active == 1 ? 0 : 1
            };
            BusinessService.SpecialAccountEdit(account.id, post_data, function (success, data) {
                if (success) NotifyService.Success('', false);
                block_accounts_list.stop();
            });
        };

        // *********************************************************************************************
        //  CREATE & EDIT PART
        // *********************************************************************************************

        /**
         * Init Account string
         */
        function initLocaleStrings(account) {
            $scope.multilang.initStrings(account, ['public_title']);
        }

        /**
         * Make currency list for <select> element
         */
        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0) BusinessService.CurrencyList(null, function (success, response) {
                if (success) {
                    $scope.data.currenciesList = response;

                    if ($scope.data.currenciesList.indexOf('EUR') == -1) $scope.data.currenciesList.push('EUR');

                    if ($scope.data.currenciesList.indexOf('USD') == -1) $scope.data.currenciesList.push('USD');
                }
            });
        }

        function getGoods(callback) {
            $scope.model.goodsList = [];

            EmbeddedService.GetGoods({service_type: 'all'}, function (success, data) {
                if (success) {
                    $scope.model.goodsList = angular.copy(data);
                }
                callback(success);
            });
        }

        /**
         * Prepare data for display page in mode 'create'
         */
        function doCreate() {
            getCurrenciesList();

            $scope.account = {
                type: 'goods', unconfirmed_redeem_amount: 0, currency: $rootScope.ENV.business.currency
            };

            getGoods(function (success) {
            });

            initLocaleStrings($scope.account);
        }

        /**
         * Prepare data for display page in mode 'edit'
         */
        function doEdit() {

            // function _makeDictTag(a) {
            //     var result = [];
            //     if (a)
            //         a.forEach(function (item) {
            //             result.push({text: item});
            //         });
            //     return result;
            // }

            //$scope.accountState.loading();
            block_account_edit.start();
            getCurrenciesList();

            function _makeDictTag(codesList) {
                var result = [];

                if (codesList) {
                    if ($scope.model.goodsList) {
                        codesList.forEach(function (code, index) {
                            var goodItem = $scope.model.goodsList.find(function (item) {
                                return item.code === code
                            })
                            if (goodItem) {
                                result.push(goodItem);
                            } else {
                                result.push({code: code, title: ''});
                            }
                        });
                    } else {
                        result = codesList;
                    }
                }

                return result;
            }

            BusinessService.SpecialAccount($routeParams.account_id, function (success, data) {
                if (success) {
                    $scope.account = angular.copy(data);
                    $scope.model.goods_codes = _makeDictTag($scope.account.goods_items);
                    getGoods(function (success) {
                        if (success) {
                            $scope.model.goods_codes = _makeDictTag($scope.account.goods_items);
                        }
                    });

                    initLocaleStrings($scope.account);
                }
                block_account_edit.stop();
            });
        }

        $scope.onChangeTab = function (tab) {
            $scope.state.currentTab = tab;
        };

        $scope.getCustomersAndEdit = function () {
            var params = angular.copy($scope.params);

            if ($scope.params.account_extended) {
                if ($scope.params.account_extended === 'all') {
                    params.account_extended = null;
                }
                if ($scope.params.account_extended === 'yes') {
                    params.account_extended = true;
                }
                if ($scope.params.account_extended === 'no') {
                    params.account_extended = false;
                }
            }

            if ($scope.params.account_credit_type === 'all') {
                params.account_credit_type = null;
            }

            block_customers_list.start();

            BusinessService.SpecialAccountCustomers($scope.account.id, $scope.data.currentFilter.id, params, function (success, data) {
                if (success) {
                    $scope.data.customers = [];

                    if (data.data.length > 0) {
                        $scope.data.customers = data.data;
                        $scope.data.total_customers_count = data.summary.total_rows_count;
                        $scope.openModalSpecialAccountExtended(data.data[0].user_id, data.data[0].id);
                        block_customers_list.stop();
                        return
                    }

                    var post_data = {
                        extended: 0,
                        customer: {
                            readonly: false,
                        }
                    }

                    if (params.user_id_type == 'external-id') {
                        post_data.customer.user_external_id = params.user_id_value;
                    }

                    if (params.user_id_type == 'phone') {
                        post_data.customer.user_phone = params.user_id_value;
                    }

                    if (params.user_id_type == 'email') {
                        post_data.customer.user_email = params.user_id_value;
                    }

                    if (params.user_id == 'id') {
                        post_data.customer.user_email = params.user_id_value;
                    }

                    BusinessService.SpecialAccountEditCustomers($scope.account.id, $scope.data.currentFilter.id, {existing_user_only: true}, post_data, function (successEdit, dataEdit) {
                        if (!successEdit) {
                            NotifyService.Error(dataEdit.message, false);
                            block_customers_list.stop();
                            return;
                        }

                        $scope.openModalSpecialAccountExtended(dataEdit.user_id, dataEdit.id);

                        block_customers_list.stop();
                    });
                }
            });
        }

        $scope.openModalSpecialAccountExtended = function (userId, accountId) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'app/pages/accounts/modals/modal.special-account.extend.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var block_form = blockUI.instances.get('account-extend-form');
                    block_form.start();
                    var popup = this;
                    popup.isCreditLimitUnlimited = false;
                    popup.isDayLimitUnlimited = false;
                    popup.isMonthLimitUnlimited = false;
                    popup.specialAccountGoods = [];
                    popup.availablePosList = [];

                    popup.changeGoodsItem = function (goodCode, event) {
                        if (!popup.account.goods_items) {
                            popup.account.goods_items = [];
                        }
                        if (popup.account.goods_items.indexOf(goodCode) == -1) {
                            popup.account.goods_items.push(goodCode);
                        } else {
                            popup.account.goods_items.splice(popup.account.goods_items.indexOf(goodCode), 1);
                        }
                    };
                    CustomerService.GetCustomerSpecialAccount(userId, accountId, function (success, data) {
                        if (success) {
                            popup.account = angular.copy(data);

                            popup.account.extended = 1;

                            popup.account.odometer = popup.account.odometer ? popup.account.odometer : 'no';
                            popup.isCreditLimitUnlimited = !(data.credit_limit);
                            popup.isDayLimitUnlimited = !(data.day_limit);
                            popup.isMonthLimitUnlimited = !(data.month_limit);

                            if (popup.account.available_until || popup.account.available_from) {
                                popup.account.available_date = 1;

                                if (popup.account.available_until) {
                                    popup.account.available_until = moment(popup.account.available_until).utcOffset(0, true).format();
                                }

                                if (popup.account.available_from) {
                                    popup.account.available_from = moment(popup.account.available_from).utcOffset(0, true).format();
                                }
                            }

                            block_form.stop();

                            POSService.All({}, function (success, data) {
                                if (success) {
                                    var posList = angular.copy(data);
                                    popup.availablePosList = posList.filter(function (pos) {
                                        return pos.active;
                                    });
                                    for (var elem in popup.account.pos) {
                                        popup.account.pos[elem] = itemByIndex(popup.availablePosList,
                                            popup.account.pos[elem].id);
                                    }
                                }

                                BusinessService.getSpecialAccountGoods(popup.account.special_account_id, function (success, data) {
                                    if (success) {
                                        popup.specialAccountGoods = angular.copy(data);
                                    }
                                    block_form.stop();
                                });

                            });
                        }

                    });

                    popup.isViewSecurityCode = false;
                    popup.viewSecurityCode = function () {
                        popup.isViewSecurityCode = !popup.isViewSecurityCode;
                    };
                    popup.saveExtendSpecialAccount = function (form) {

                        if (!form.security_code.$valid) {
                            form.security_code.$dirty = true;
                            return;
                        } else {
                            form.security_code.$dirty = false;
                        }

                        block_form.start();

                        var account = angular.copy(popup.account);

                        if (account.security_code == '') {
                            account.security_code = null;
                        }

                        if (account.available_date) {
                            if (account.available_from) {
                                account.available_from = moment(account.available_from).utc().toISOString();
                            }

                            if (account.available_until) {
                                account.available_until = moment(account.available_until).utc().toISOString();
                            }
                        } else {
                            account.available_from = null;
                            account.available_until = null;
                        }

                        delete account.available_date;

                        if (!!account.extended) {
                            CustomerService.UpdateSpecialAccountCustomer(userId, accountId, account, function (success, data) {

                                if (!success) {
                                    NotifyService.Error(data.message, false);
                                    return;
                                }

                                if (success) {
                                    getCustomers();
                                    block_form.stop();
                                    $uibModalInstance.close();
                                }
                            });
                        } else {
                            CustomerService.UpdateSpecialAccountCustomer(userId, accountId, {extended: 0}, function (success, data) {

                                if (!success) {
                                    NotifyService.Error(data.message, false);
                                    return;
                                }

                                if (success) {
                                    getCustomers();
                                    block_form.stop();
                                    $uibModalInstance.close();
                                }

                            });
                        }
                    };
                    popup.closeModal = function (exit) {
                        getCustomers();
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $scope.getCustomers = getCustomers;

        function getCustomers() {
            block_customers_list.start();
            var params = angular.copy($scope.params);

            if ($scope.params.account_extended) {
                if ($scope.params.account_extended === 'all') {
                    params.account_extended = null;
                }
                if ($scope.params.account_extended === 'yes') {
                    params.account_extended = true;
                }
                if ($scope.params.account_extended === 'no') {
                    params.account_extended = false;
                }
            }

            if ($scope.params.account_credit_type === 'all') {
                params.account_credit_type = null;
            }

            BusinessService.SpecialAccountCustomers($scope.account.id, $scope.data.currentFilter.id, params, function (success, data) {
                if (success) {
                    $scope.data.customers = data.data;
                    $scope.data.total_customers_count = data.summary.total_rows_count;
                }
                block_customers_list.stop();
            });
        }

        $scope.pageChange = function () {
            getCustomers();
        };

        $scope.onCountChange = function (count) {
            $scope.params.page = 1;
            $scope.params.count = count;
            getCustomers();
        };

        $scope.onCustomersExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_customers_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;
            block_customers_list.start();

            var params = angular.copy($scope.params);

            if ($scope.params.account_extended) {
                if ($scope.params.account_extended === 'all') {
                    params.account_extended = null;
                }
                if ($scope.params.account_extended === 'yes') {
                    params.account_extended = true;
                }
                if ($scope.params.account_extended === 'no') {
                    params.account_extended = false;
                }
            }

            if ($scope.params.account_credit_type === 'all') {
                params.account_credit_type = null;
            }

            params.slow_request = true;
            params = cleanRequestData(params);

            var tl = [];

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_customers';
                var export_struct = [];
                for (var i in $scope.table_cols) {
                    if ($scope.table_cols[i].visible && !$scope.table_cols[i].no_export) {
                        for (var k in $scope.table_cols[i].data) {
                            if ($scope.table_cols[i].data[k].visible && !!$scope.table_cols[i].data[k] && !$scope.table_cols[i].data[k].no_export) {
                                export_struct.push({
                                    text: $filter('translate')($scope.table_cols[i].data[k].text),
                                    value: $scope.table_cols[i].data[k].value
                                });
                            }
                        }
                    }
                }

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        var a, b;
                        a = export_struct[k].text;
                        switch (export_struct[k].value) {
                            case 'user_phone':
                            case 'user_email':
                            case 'user_status':
                            case 'user_external_id':
                            case 'user_name':
                            case 'user_birth_date':
                            case 'user_country':
                            case 'user_language':
                                if (!tl[i].customer || !tl[i].customer[export_struct[k].value]) {
                                    b = '';
                                    break;
                                }
                                b = tl[i].customer && tl[i].customer[export_struct[k].value] ? tl[i].customer[export_struct[k].value] : '';
                                break;
                            case 'user_gender':
                                if (!tl[i].customer || !tl[i].customer[export_struct[k]]) {
                                    b = '';
                                    break;
                                }
                                b = (!tl[i].customer[export_struct[k].value]) ? '' : $filter('translate')(tl[i].customer[export_struct[k].value]);
                                break;
                            case 'customer_additional_cards':
                                if (!tl[i].customer || !tl[i].customer[export_struct[k].value]) {
                                    b = '';
                                    break;
                                }
                                b = !tl[i].customer || tl[i].customer[export_struct[k].value] === null ? '' : tl[i].customer[export_struct[k].value];
                                break;
                            case 'goods_items':
                                b = !tl[i] || tl[i][export_struct[k].value] === null || !tl[i][export_struct[k].value] || (tl[i][export_struct[k].value] && tl[i][export_struct[k].value].length === 0) ? '' : tl[i][export_struct[k].value].join();
                                break;
                            case 'pos':
                                b = !tl[i] || tl[i][export_struct[k].value] === null || !tl[i][export_struct[k].value] || (tl[i][export_struct[k].value] && tl[i][export_struct[k].value].length === 0) ? '' : tl[i][export_struct[k].value].map(function (item) {
                                    return item.id;
                                }).join();
                                break;
                            case 'day_limit':
                            case 'month_limit':
                            case 'credit_limit':
                            case 'security_code':
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                                break;
                            case 'odometer':
                                b = (!tl[i][export_struct[k].value]) ? '' : $filter('translate')('Special account odometer#' + tl[i][export_struct[k].value]);
                                break;
                            case 'credit_type':
                                b = (!tl[i][export_struct[k].value]) ? '' : $filter('translate')('credit_type_' + tl[i][export_struct[k].value]);
                                break;
                            default:
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                        }
                        el[a] = b;
                    }
                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                    block_customers_list.stop();
                });
                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }

            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.data.total_customers_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    getCustomers(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp];
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.data.total_customers_count);
                        if (!isExportStopped && !$scope.exportModal.isExportPaused && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            });
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                });
            }

            function getCustomers(params) {
                return new Promise(function (resolve) {
                    BusinessService.SpecialAccountCustomers($scope.account.id, $scope.data.currentFilter.id, params, function (success, data) {
                        resolve(data);
                    });
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                tl = result.data;
                tl.forEach(function (item) {
                    item.id = item.user_id;
                });

                generateFile();
            }

            exportRequest();
        };

        //Import block

        function getCustomerFields() {
            CustomerService.CustomerFields(function (success, data) {
                if (success) {
                    data.forEach(function (item) {
                        $scope.dataImport.fields.push({
                            id: item.id, title: item.description, type: item.type, group: 'custom'
                        });
                    });
                }
            });
        }

        function isValidGender(g) {
            var gs = [{male: ['male', 'мужской', 'чоловік', 'kişi', 'mężczyzna']}, {female: ['female', 'женский', 'жінка', 'qadın', 'kobieta']}, {other: ['other', 'другой', 'інша', 'digər', 'inne']}];

            for (var i in gs) for (var k in gs[i]) if (gs[i][k].indexOf(g.toLowerCase()) !== -1) return k;

            return false;
        }

        function isValidOdometerValue(g) {
            var opt = [{possible: ['запрашивать, но не требовать', 'request as optional', 'запитувати, але не вимагати', 'possible']}, {yes: ['требовать ввод', 'request as mandatory', 'вимагати введення', 'yes']}, {no: ['не запрашивать', 'do not request', 'не запитувати', 'no']}];

            for (var i in opt) for (var k in opt[i]) if (opt[i][k].indexOf(g.toLowerCase()) !== -1) return k;

            return false;
        }

        function isCreditType(value) {
            var lmts = [{'debit': ['debit (prepaid)', 'дебетовий (із попереднім поповненням)', 'дебетовый (предоплаченный)', 'debit']}, {'credit': ['credit with limits', 'кредитний з лімітом', 'кредитный с лимитом', 'credit']}, {'credit-unlimited': ['unlimited credit', 'кредитний без ліміту', 'кредитный без лимита', 'credit-unlimited']}];

            for (var i in lmts) for (var k in lmts[i]) if (lmts[i][k].indexOf(value.toLowerCase()) !== -1) return k;

            return false;
        }

        $scope.onFileSelect = function () {
            var file = angular.element(document.getElementById('dataFileInput'));
            file.val(null);

            $scope.error.message = null;
        };

        $scope.fileChanged = function (event) {
            var a = event.srcElement.value.split('.');
            $scope.status.file_type = a[a.length - 1];

            // Reset data
            // getImportPreferences();
            $scope._importPageMode = 'default';

            if ($scope.dataImport.imported) {
                $scope.dataImport.imported.length = 0;
            }
            $scope.dataImport.imported = null;

            if ($scope.dataImport.processed) {
                $scope.dataImport.processed.length = 0;
            }
            $scope.dataImport.processed = null;
            // Reset data

            $scope.model.headerExist = false;
            // Reset file options

            block_import_customers.start();
            $timeout(function () {

                try {
                    alasql.promise('SELECT * FROM FILE(?,{headers:false})', [event]).then(function (data) {
                        block_import_customers.stop();
                        if (data) {

                            if (!!Object.keys) {
                                data = data.filter(function (value) {
                                    return Object.keys(value).length !== 0;
                                });
                            }

                            importData(data);
                        }
                    });

                } catch (e) {
                    block_import_customers.stop();
                }
            }, 200, true);
        };

        function importData(data) {
            if (!data) return null;

            // $scope.data.imported = angular.copy(data);
            $scope.$apply(function () {
                $scope.dataImport.imported = angular.copy(data);
            });

            processData();
        }

        function processData() {
            if (!$scope.dataImport.imported) return null;

            var block_ui = $scope._importPageMode == 'preview' ? blockUI.instances.get('import_customers_preferences') : blockUI.instances.get('import_customers');
            block_ui.start();

            if ($scope.dataImport.processed) {
                $scope.dataImport.processed.length = 0;
            }
            $scope.dataImport.processed = null;
            $scope.dataImport.summary.total_rows_count = 0;
            $scope.dataImport.headers = [];

            // var promise = processDataCore();
            processDataCore2().then(function (value) {
            }, function (error) {
            }).finally(function () {
                block_ui.stop();
            });
            // block_ui.stop();
        }

        function processDataCore2() {


            return new Promise(function (resolve, reject) {

                if (!$scope.dataImport.imported) {
                    reject('NO DATA');
                    return;
                }


                // var data = angular.copy($scope.data.imported);
                var data = null, a = [];

                if (($scope.status.file_type === 'csv' || $scope.status.file_type === 'txt') && Object.keys($scope.dataImport.imported[0]).length === 1 && typeof Object.values($scope.dataImport.imported[0])[0] === 'string' && Object.values($scope.dataImport.imported[0])[0].indexOf(';') !== -1) {

                    data = [];
                    for (var i in $scope.dataImport.imported) {
                        for (var k in $scope.dataImport.imported[i]) {
                            data.push($scope.dataImport.imported[i][k].split(';'));
                        }
                    }
                } else {
                    data = angular.copy($scope.dataImport.imported);
                }


                // Prepare headers
                var props = {}, longest_row = data[0], hdr = null;

                for (var i in data) {
                    if (Object.keys(longest_row).length < Object.keys(data[i]).length) {
                        longest_row = data[i];
                    }
                }

                if ($scope.model.headerExist) {
                    hdr = data.shift();
                }

                for (var i in longest_row) {
                    props[i] = i;

                    var htitle = props[i];
                    if (hdr && hdr[props[i]]) {
                        htitle = hdr[props[i]];
                    }

                    $scope.dataImport.headers.push({title: htitle, field: 'none'});
                }


                // Prepare data for preview
                for (var i in data) {
                    a[i] = [];

                    for (var l in props) {
                        if (data[i][props[l]]) {
                            a[i].push(data[i][props[l]]);
                        } else {
                            a[i].push('');
                        }
                    }
                }

                $scope.dataImport.summary.total_rows_count = a.length;

                $scope.dataImport.processed = angular.copy(a);

                if ($scope.dataImport.processed) {

                    $scope._importPageMode = 'preview';
                    // $scope.$apply(function(){
                    //     $scope._pageMode = "preview";
                    // });


                    var d = $scope.dataImport.processed, h = $scope.dataImport.headers, pi = null; // phone column index

                    if (!d || !d[0] || !h) {
                        return null;
                    }

                    if (h.length === 0) {
                        for (var i = 0; i < d[0].length; i++) {
                            h.push({title: '', field: 'none'});
                        }
                    }

                    for (var i in d) {
                        if (!pi) {
                            for (var k in d[i]) {
                                if ($scope.dataImport.primary_id_type === 'email') {
                                    if (typeof d[i][k] === 'string' && isEmailValid(d[i][k])) {
                                        pi = k;
                                    }
                                } else {
                                    if (typeof d[i][k] === 'string' && d[i][k].indexOf('+') === 0) {
                                        pi = k;
                                    } else if (typeof d[i][k] === 'number' && isPhoneValid('+' + d[i][k])) {
                                        pi = k;
                                    }
                                }
                            }
                        } else {
                            break;
                        }
                    }

                    if (pi) {
                        for (var i in h) {
                            if (i === pi) {
                                h[i].field = $scope.dataImport.primary_id_type;
                            }
                        }
                    }

                    resolve('OK');
                    return;


                } else {
                    resolve('OK');
                    return;
                }


            });


        }

        function processDataCore() {

            var deferred = $q.defer();

            $timeout(function () {

                if (!$scope.dataImport.imported) deferred.reject('NO DATA');

                // var data = angular.copy($scope.data.imported);
                var data = null, a = [];

                if (($scope.status.file_type === 'csv' || $scope.status.file_type === 'txt') && Object.keys($scope.dataImport.imported[0]).length === 1 && typeof Object.values($scope.dataImport.imported[0])[0] === 'string' && Object.values($scope.dataImport.imported[0])[0].indexOf(';') !== -1) {

                    data = [];
                    for (var i in $scope.dataImport.imported) {
                        for (var k in $scope.dataImport.imported[i]) {
                            data.push($scope.dataImport.imported[i][k].split(';'));
                        }
                    }
                } else {
                    data = angular.copy($scope.dataImport.imported);
                }

                $timeout(function () {

                    // Prepare headers
                    var props = {}, longest_row = data[0], hdr = null;

                    for (var i in data) {
                        if (Object.keys(longest_row).length < Object.keys(data[i]).length) {
                            longest_row = data[i];
                        }
                    }

                    if ($scope.model.headerExist) {
                        hdr = data.shift();
                    }

                    for (var i in longest_row) {
                        props[i] = i;

                        var htitle = props[i];
                        if (hdr && hdr[props[i]]) {
                            htitle = hdr[props[i]];
                        }

                        $scope.dataImport.headers.push({title: htitle, field: 'none'});
                    }

                    $timeout(function () {
                        // Prepare data for preview
                        for (var i in data) {
                            a[i] = [];

                            for (var l in props) {
                                if (data[i][props[l]]) {
                                    a[i].push(data[i][props[l]]);
                                } else {
                                    a[i].push('');
                                }
                            }
                        }

                        $scope.dataImport.summary.total_rows_count = a.length;

                        $scope.dataImport.processed = angular.copy(a);

                        if ($scope.dataImport.processed) {

                            $scope._importPageMode = 'preview';
                            // $scope.$apply(function(){
                            //     $scope._pageMode = "preview";
                            // });

                            $timeout(function () {
                                var d = $scope.dataImport.processed, h = $scope.dataImport.headers, pi = null; // phone column index

                                if (!d || !d[0] || !h) {
                                    return null;
                                }

                                if (h.length === 0) {
                                    for (var i = 0; i < d[0].length; i++) {
                                        h.push({title: '', field: 'none'});
                                    }
                                }

                                for (var i in d) {
                                    if (!pi) {
                                        for (var k in d[i]) {
                                            if ($scope.dataImport.primary_id_type === 'email') {
                                                if (typeof d[i][k] === 'string' && isEmailValid(d[i][k])) {
                                                    pi = k;
                                                }
                                            } else {
                                                if (typeof d[i][k] === 'string' && d[i][k].indexOf('+') === 0) {
                                                    pi = k;
                                                } else if (typeof d[i][k] === 'number' && isPhoneValid('+' + d[i][k])) {
                                                    pi = k;
                                                }
                                            }
                                        }
                                    } else {
                                        break;
                                    }
                                }

                                if (pi) {
                                    for (var i in h) {
                                        if (i === pi) {
                                            h[i].field = $scope.dataImport.primary_id_type;
                                        }
                                    }
                                }

                                deferred.resolve('OK');
                            }, 200, true);

                        } else {
                            deferred.resolve('OK');
                        }
                    }, 200, true);
                }, 200, true);
            }, 200, true);

            return deferred.promise;
        }

        $scope.onColumnMomentFormatChange = function (index) {
            $scope.onColumnValueChange($scope.dataImport.headers[index].field, index);
        };

        $scope.onColumnValueChange = function (field, index) {
            var r_index, a_index, d_index, c_index;

            for (var i in $scope.dataImport.headers) if (index * 1 !== i * 1 && ($scope.dataImport.headers[i].field === field)) $scope.dataImport.headers[i].field = 'none';

            if (r_index) for (var i in $scope.dataImport.processed) if (parseFloat($scope.dataImport.processed[i][r_index])) {
                var v = $scope.dataImport.processed[i][r_index];

                if (v && typeof v === 'string' && (v.match(/,/g) || []).length === 1 && v.indexOf('.') === -1) v = v.replace(',', '.');

                v = Math.floor(parseFloat(v) * 100) / 100;
                $scope.dataImport.processed[i][r_index] = v;
            } else {
                $scope.dataImport.processed[i][r_index] = 0;
            }

            if (a_index) for (var i in $scope.dataImport.processed) if (!$scope.dataImport.processed[i][a_index]) $scope.dataImport.processed[i][a_index] = $scope.dataImport.specialAccountsList[0].id;

            if (c_index) for (var i in $scope.dataImport.processed) if ($scope.dataImport.processed[i][c_index].length === 3) $scope.dataImport.processed[i][c_index] = $scope.dataImport.processed[i][c_index].toUpperCase();

            if (d_index) {
                for (var i in $scope.dataImport.processed) {

                    if (!!$scope.dataImport.moment_format_parse_expire_date) {
                        var d = moment($scope.dataImport.processed[i][d_index], $scope.dataImport.moment_format_parse_expire_date);
                    } else {
                        var d = moment($scope.dataImport.processed[i][d_index]);
                    }

                    if (d.isValid()) $scope.dataImport.processed[i][d_index] = d.toDate();
                }
            }

            $scope.error.message = null;
        };

        $scope.onImportCountChange = function (count) {
            $scope.importParams.customers.page = 1;
            $scope.importParams.customers.count = count;
        };

        $scope.getCellFieldType = function (index) {
            if ($scope.dataImport.headers[index]) return $scope.dataImport.headers[index].field; else return null;
        };

        $scope.unsetExpireDate = function (pi, i) {
            $scope.dataImport.processed[pi][i] = undefined;
        };

        $scope.onImportClick = function () {
            $scope.error.message = null;
            var pi;
            for (var i in $scope.dataImport.headers) {
                if ($scope.dataImport.primary_id_type === 'email') {
                    if ($scope.dataImport.headers[i].field === 'email') {
                        if (pi) {
                            $scope.error.message = 'TEXT_ERROR_ONLY_ONE_EMAIL_COLUMN_PERMITED';
                            break;
                        } else {
                            pi = i;
                        }
                    }
                } else if ($scope.dataImport.primary_id_type === 'phone') {
                    if ($scope.dataImport.headers[i].field === 'phone') {
                        if (pi) {
                            $scope.error.message = 'TEXT_ERROR_ONLY_ONE_PHONE_COLUMN_PERMITED';
                            break;
                        } else {
                            pi = i;
                        }
                    }
                } else {
                    if ($scope.dataImport.headers[i].field === 'external_id') {
                        if (pi) {
                            $scope.error.message = 'TEXT_ERROR_ONLY_EXTERNAL_ID_COLUMN_PERMITED';
                            break;
                        } else {
                            pi = i;
                        }
                    }
                }
            }

            if (!pi) {
                if ($scope.dataImport.primary_id_type === 'email') {
                    $scope.error.message = 'TEXT_ERROR_EMAIL_COLUMN_REQUIRED';
                } else if ($scope.dataImport.primary_id_type === 'phone') {
                    $scope.error.message = 'TEXT_ERROR_PHONE_COLUMN_REQUIRED';
                } else {
                    $scope.error.message = 'TEXT_ERROREXTERNAL_ID_COLUMN_REQUIRED';
                }
            }

            if (!$scope.error.message) {

                // $scope._importPageMode = 'progress';
                // Prepare post data

                var import_data = [];

                for (var i in $scope.dataImport.processed) {
                    var data = {
                        extended: 1, customer: {
                            readonly: false
                        }
                    };
                    for (var k in $scope.dataImport.processed[i]) {
                        var f = $scope.dataImport.headers[k].field, v = $scope.dataImport.processed[i][k];

                        if (f !== 'none' && v) {
                            switch (f) {
                                case 'user_gender':
                                    v = isValidGender(v);
                                    break;
                                case 'phone':
                                case 'external_id':
                                case 'email':
                                case 'user_birth_date':
                                case 'customer_additional_cards':
                                case 'user_name':
                                case 'user_country':
                                case 'user_language':
                                case 'access_type':
                                    if (f === 'phone' && v && v.toString().indexOf('+') === -1) v = '+' + v;

                                    if (f === 'external_id') v = v.toString();

                                    if (f === 'customer_additional_cards') {
                                        v = v.toString().replace(/\s/g, '').split(/[;,\/]/);
                                    }

                                    data.customer[f] = v;
                                    break;

                                case 'goods_items':
                                case 'pos':
                                case 'credit_type':
                                case 'odometer':
                                    if (f === 'pos') {
                                        var pos = [];
                                        v.replace(/\s/g, '').split(/[;,\/]/).forEach(function (res) {
                                            pos.push({id: res});
                                        });
                                        v = pos;
                                    }

                                    if (f === 'goods_items') {
                                        v = v.replace(/\s/g, '').split(/[;,\/]/);
                                    }

                                    if (f === 'credit_type') v = isCreditType(v);

                                    if (f === 'odometer') v = v ? isValidOdometerValue(v) : null;

                                    data[f] = v;
                                    break;
                                case 'amount':
                                    data.transaction = {
                                        amount: parseFloat(v), type: 'special-account-refill'
                                    };
                                    break;
                                case 'security_code':
                                    data[f] = v.toString();
                                    break;
                                default:
                                    data[f] = v;

                            }
                        }
                    }
                    import_data.push(data);
                }

                if (!$scope.data.currentFilter) {
                    $scope.error.message = 'Brand required';
                }

                if (import_data && import_data.length > 0 && $scope.data.currentFilter) {
                    block_import_customers.start();
                    $scope.status.import_progress = 0;

                    $scope._importPageMode = 'progress';

                    var nextCall = function (index) {
                        var row = index;
                        if ($scope.model.headerExist) {
                            row += 1;
                        }
                        if (!$rootScope.REQUEST_ABORT_PENDING) {
                            BusinessService.SpecialAccountImportCustomers($routeParams.account_id, $scope.data.currentFilter.id, import_data[index], function (success, data) {
                                $scope.status.import_progress += $scope.status.chunk_size / (import_data.length - 1);

                                if (!success) {
                                    $scope.status.result.errors.push({
                                        message: data.message, row: row + 1, value: JSON.stringify(import_data[index])
                                    });
                                    $scope.status.result.error += 1;
                                }

                                if (success) {
                                    if (import_data[index].credit_limit && data.credit_type === 'debit') {
                                        $scope.status.result.error += 1;
                                        $scope.status.result.errors.push({
                                            message: $filter('translate')('Your account type Debit does not support Credit Limit'),
                                            row: row + 1,
                                            value: JSON.stringify(import_data[index])
                                        });
                                    }

                                    if (import_data[index].credit_limit && data.credit_type === 'credit-unlimited') {
                                        $scope.status.result.error += 1;
                                        $scope.status.result.errors.push({
                                            message: $filter('translate')('Your account type Credit without limit does not support Credit limit'),
                                            row: row + 1,
                                            value: JSON.stringify(import_data[index])
                                        });
                                    }

                                    $scope.status.result.add += 1;
                                }
                                ++$scope.status.current_chunk;
                                if (import_data.length - 1 !== index) {
                                    nextCall(index + 1);
                                } else {
                                    $scope._importPageMode = 'result';
                                    block_import_customers.stop();
                                }
                            });
                        } else {
                            $rootScope.REQUEST_ABORT_PENDING = false;
                            block_import_customers.stop();
                        }
                    };
                    nextCall(0);
                }
            }
        };

        $scope.onImportAgainClick = function () {
            $scope._importPageMode = 'default';

            $scope.dataImport.headers = [];
            $scope.dataImport.processed = null;

            $scope.status = {
                import_progress: 0, chunk_size: 100, current_chunk: 0, result: {
                    data: {
                        fields: null, rows: []
                    }, add: 0, update: 0, error: 0, errors: []
                }
            };
        };

        $scope.onErrosLogExport = function (format) {
            var file_name = $rootScope.ENV.business.code + '_import_errors_' + moment().format('YYYY-MM-DD_HH:mm:ss');

            switch (format) {
                case 'XLSX':
                    alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [$scope.status.result.errors]);
                    break;
                case 'XLS':
                    alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [$scope.status.result.errors]);
                    break;
                case 'CSV':
                    alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [$scope.status.result.errors]);
                    break;
            }
        };

        $scope.onProcessAbort = function () {
            $rootScope.REQUEST_ABORT_PENDING = true;
            $scope._importPageMode = 'result';
        };

        /**
         * Cancel editing
         */
        $scope.onCancelEdit = function () {
            $location.path('/client-accounts');
        };

        /**
         * Add or update account
         * @param form
         * @param {boolean} isClose
         */
        $scope.onAccountSave = function (form, isClose) {
            console.info('FORM', form);

            function _makeTagArray(d) {
                var result = [];
                if (d) d.forEach(function (item) {
                    result.push(item.code);
                });
                return result.filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                });
            }

            $scope.account.goods_items = _makeTagArray($scope.model.goods_codes || form.goods.$modelValue) || null;
            //  $scope.account.goods_items = $scope.account.type == 'goods' ? _makeTagArray($scope.model.goods_codes || form.goods.$modelValue) : null;
            var needGoods = ($scope.account.type == 'goods' && (!$scope.account.goods_items || $scope.account.goods_items.length == 0));
            var needCurrency = ($scope.account.type == 'money' && !$scope.account.currency);

            console.info('ACCOUNT', $scope.account);
            console.info('needGoods', needGoods);

            /**
             * Callback response
             * @param {boolean} success
             * @param response
             */
            function _makeDictTag(codesList) {
                var result = [];

                if (codesList) {
                    if ($scope.model.goodsList) {
                        codesList.forEach(function (code, index) {
                            var goodItem = $scope.model.goodsList.find(function (item) {
                                return item.code === code
                            })
                            if (goodItem) {
                                result.push(goodItem);
                            } else {
                                result.push({code: code, title: ''});
                            }
                        });
                    } else {
                        result = codesList;
                    }
                }

                return result;
            }

            function handleResult(success, response) {
                if (success) {
                    $scope.model.goods_codes = _makeDictTag(response.goods_items);
                    NotifyService.Success('', false);
                    if (isClose) {
                        $location.path('/client-accounts');
                    }
                }
            }

            if (form.title.$valid && form.public_title.$valid && !needGoods && !needCurrency) {
                var account = angular.copy($scope.account);
                if (!!account.id) {
                    BusinessService.SpecialAccountEdit(account.id, account, handleResult);
                } else {
                    BusinessService.SpecialAccountAdd(account, handleResult);
                }
            } else {
                if ($scope.account.type == 'goods') {
                    form.goods.$dirty = true;
                    form.goods.$invalid = needGoods;
                }
                if ($scope.account.type == 'money') {
                    form.currency.$dirty = true;
                    form.currency.$invalid = needCurrency;
                }

                form.public_title.$dirty = form.title.$dirty = true;
                console.info('FORM', form);
            }
        };

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
        };

        $scope.goodsTagHandler = function (code) {
            return {title: '', code: code};
        };

        $scope.pasteTagHandler = function (values) {
            var separators = [',', '\n'], separator, values_list;

            for (var i in separators) if (values && values.indexOf(separators[i]) > 0) separator = separators[i];

            if (separator) values_list = values.replace(' ', '').split(separator); else values_list = values.split(' ');

            if (values_list && values_list.length > 0) {
                values_list = values_list.filter(function (elem, index, self) {
                    return index == self.indexOf(elem);
                });

                for (var i in values_list) {
                    if (!this.ngModel.$modelValue) this.ngModel.$modelValue = [];
                    if (values_list[i]) {
                        this.ngModel.$modelValue.push({title: '', code: values_list[i]});
                    }
                }
            }
        };

        $scope.popupWriteOffSpecialAccount = function (customer, special_account_id) {
            console.info('popupWriteOffSpecialAccount', customer);
            confirmationPopup('WriteOffSpecialAccount', customer, special_account_id, function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/templates/modal.customer.write-off-special-account.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.model = {};
                        popup.data = {};

                        popup.disableSelectAccount = true;

                        popup.usersCount = 1;
                        popup.selectedCount = 1;
                        popup.sendTo = 'user';
                        popup.user = customer;
                        popup.step = 0;
                        $rootScope.REQUEST_ABORT_PENDING = false;

                        popup.terminalNames = '';
                        popup.model.special_account_id = special_account_id;

                        SelectService.getRegistersList(function (success, response) {
                            if (success) {
                                popup.data.registersList = [];
                                for (var i in response) {
                                    if (response[i].loyalty_id === $scope.data.currentFilter.id && response[i].active === 1)
                                        popup.data.registersList.push(response[i]);
                                }

                                if (popup.data.registersList.length > 0) {
                                    popup.model.terminal_id = popup.data.registersList[0].id;
                                    popup.terminalNames = getTerminalsNames(popup.data.registersList);
                                }
                            }
                        });

                        SelectService.getSpecialAccountsListCB(function (success, response) {
                            if (success) {
                                popup.data.accountsList = [];
                                for (var i in response)
                                    if (response[i].active === 1)
                                        popup.data.accountsList.push(response[i]);
                            }
                        });

                        popup.onOk = function () {
                            if (popup.step == 1) {
                                var post_data = {
                                    loyalty_id: $scope.data.currentFilter.id,
                                    special_account_id: popup.model.special_account_id,
                                    terminal_id: popup.model.terminal_id,
                                    comment: popup.model.comment,
                                    message: popup.model.message,
                                    amount: popup.model.charge_amount,
                                    amount_decimal_digits: 2,
                                    bonuses_decimal_digits: 2,
                                    special_accounts_decimal_digits: 2
                                };

                                $scope.sendingResult = {
                                    error_log: []
                                };

                                popup.model.chunk_size = 25;
                                popup.model.users = [];
                                popup.model.total_elements = 1;

                                popup.model.request_progress = 0.1;
                                var processRequestOptions = {
                                    update_user_list: true,
                                    error_log: true,
                                    callbackOnSuccess: function () {
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_WRITE_OFF_SPECIAL_ACCOUNT'), false);
                                    }
                                };

                                popup.model.users = [popup.user.user_id];
                                processRequest(popup, post_data, TransactionService.WriteOffSpecialAccounts, $uibModalInstance, processRequestOptions);

                            } else popup.step += 1;
                        };

                        popup.onRequestAbort = function () {
                            $rootScope.REQUEST_ABORT_PENDING = true;
                            popup.model.request_progress = 0;
                        };

                        popup.onShowSpecialAccounts = function () {
                            $uibModalInstance.close();
                            $location.path('/client-accounts');
                        };

                        popup.onCancel = function (exit) {
                            if (!exit) popup.step -= 1;
                            if (exit || popup.step < 0) $uibModalInstance.close();
                        };
                    }
                });
            });
        }

        $scope.popupRefillSpecialAccount = function (customer, special_account_id) {
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.refillspecialaccount.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.model = {};
                    popup.data = {};
                    popup.model.special_account_id = special_account_id;
                    popup.disableSelectAccount = true;

                    popup.usersCount = [];
                    popup.sendTo = 'user';
                    popup.user = customer;
                    popup.selectedCount = 1;
                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.terminalNames = '';
                    SelectService.getRegistersList(function (success, response) {
                        if (success) {
                            popup.data.registersList = [];
                            for (var i in response) {
                                if (response[i].loyalty_id === $scope.data.currentFilter.id && response[i].active === 1)
                                    popup.data.registersList.push(response[i]);
                            }

                            if (popup.data.registersList.length > 0) {
                                popup.model.terminal_id = popup.data.registersList[0].id;
                                popup.terminalNames = getTerminalsNames(popup.data.registersList);
                            }
                        }
                    });

                    SelectService.getSpecialAccountsListCB(function (success, response) {
                        if (success) {
                            popup.data.accountsList = [];
                            for (var i in response)
                                if (response[i].active === 1)
                                    popup.data.accountsList.push(response[i]);
                        }
                    });

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                loyalty_id: $scope.data.currentFilter.id,
                                special_account_id: popup.model.special_account_id,
                                terminal_id: popup.model.terminal_id,
                                comment: popup.model.comment,
                                message: popup.model.message,
                                amount: popup.model.charge_amount,
                                amount_decimal_digits: 2,
                                bonuses_decimal_digits: 2,
                                special_accounts_decimal_digits: 2
                            };

                            $scope.sendingResult = {
                                error_log: []
                            };

                            popup.model.chunk_size = 25;

                            popup.model.users = [];
                            popup.model.total_elements = 1;

                            popup.model.request_progress = 0.1;


                            var processRequestOptions = {
                                update_user_list: true,
                                error_log: true,
                                callbackOnSuccess: function () {
                                    NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_REFILL_SPECIAL_ACCOUNT'), false);
                                }
                            };
                            popup.model.users = [popup.user.user_id];
                            processRequest(popup, post_data, TransactionService.RefillSpecialAccounts, $uibModalInstance, processRequestOptions);

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onShowSpecialAccounts = function () {
                        $uibModalInstance.close();
                        $location.path('/client-accounts');
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.popupBalanceAdjustmentSpecialAccount = function(customer, special_account_id) {
            console.info('popupBalanceAdjustmentSpecialAccount', customer);
            confirmationPopup('AdjustmentSpecialAccount', customer, special_account_id, function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/templates/modal.customer.adjustment-special-account.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.model = {};
                        popup.data = {};

                        popup.usersCount = 1;
                        popup.selectedCount = 1;
                        popup.user = customer;
                        popup.sendTo = 'user';
                        popup.disableSelectAccount = true;
                        popup.model.special_account_id = special_account_id;
                        popup.step = 0;
                        $rootScope.REQUEST_ABORT_PENDING = false;

                        popup.terminalNames = '';

                        SelectService.getRegistersList(function (success, response) {
                            if (success) {
                                popup.data.registersList = [];
                                for (var i in response) {
                                    if (response[i].loyalty_id === $scope.data.currentFilter.id && response[i].active === 1)
                                        popup.data.registersList.push(response[i]);
                                }

                                if (popup.data.registersList.length > 0) {
                                    popup.model.terminal_id = popup.data.registersList[0].id;
                                    popup.terminalNames = getTerminalsNames(popup.data.registersList);
                                }
                            }
                        });

                        SelectService.getSpecialAccountsListCB(function (success, response) {
                            if (success) {
                                popup.data.accountsList = [];
                                for (var i in response)
                                    if (response[i].active === 1)
                                        popup.data.accountsList.push(response[i]);
                            }
                        });

                        popup.onOk = function () {
                            if (popup.step == 1) {
                                var post_data = {
                                    loyalty_id: $scope.data.currentFilter.id,
                                    special_account_id: popup.model.special_account_id,
                                    terminal_id: popup.model.terminal_id,
                                    comment: popup.model.comment,
                                    message: popup.model.message,
                                    amount: popup.model.charge_amount,
                                    amount_decimal_digits: 2,
                                    bonuses_decimal_digits: 2,
                                    special_accounts_decimal_digits: 2
                                };

                                if ($scope.data.currentFilter.filter_list_type === 'pos')
                                    post_data.pos_id = $scope.data.currentFilter.id;

                                $scope.sendingResult = {
                                    error_log: []
                                };

                                popup.model.chunk_size = 25;

                                popup.model.users = [];
                                popup.model.total_elements = 1;

                                popup.model.request_progress = 0.1;
                                var processRequestOptions = {
                                    update_user_list: true,
                                    error_log: true,
                                    callbackOnSuccess: function () {
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_ADJUSTMENT_SPECIAL_ACCOUNT'), false);
                                    }
                                };
                                popup.model.users = [popup.user.user_id];
                                processRequest(popup, post_data, TransactionService.AdjustmentSpecialAccounts, $uibModalInstance, processRequestOptions);

                            } else popup.step += 1;
                        };

                        popup.onRequestAbort = function () {
                            $rootScope.REQUEST_ABORT_PENDING = true;
                            popup.model.request_progress = 0;
                        };

                        popup.onShowSpecialAccounts = function () {
                            $uibModalInstance.close();
                            $location.path('/client-accounts');
                        };

                        popup.onCancel = function (exit) {
                            if (!exit) popup.step -= 1;
                            if (exit || popup.step < 0) $uibModalInstance.close();
                        };
                    }
                });
            });

        }

        function getTerminalsNames(terminals) {
            var terminalNames = '';
            if (terminals.length === 1) {
                terminalNames = terminals[0].title + (terminals[0].phone ? (' (' + terminals[0].phone + ')') : '');
            } else {
                terminals.forEach(function (terminal) {
                    terminalNames += terminal.title + (terminal.phone ? (' (' + terminal.phone + '), ') : ', ');
                });
                terminalNames = terminalNames.slice(0, -2);
            }
            return terminalNames;
        }


        function confirmationPopup(type_confirmation, customer, special_account_id, callbackDone) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/customers/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type_confirmation = type_confirmation;

                    popup.onDoneClick = function () {
                        $uibModalInstance.close();
                        if (callbackDone) {
                            callbackDone();
                        }
                    };

                    popup.onSpecialAccountAdjustment = function () {
                        $uibModalInstance.close();
                        $scope.popupBalanceAdjustmentSpecialAccount(customer, special_account_id);
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        function processRequest(popup, post_data, request, modal, options) {
            $scope.model.inlineMessage = '';
            popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
            post_data.users = popup.model.chunk;

            if (!post_data.type) {
                post_data.type = popup.model.delivery_method;
            }

            function handleResult(success, data) {
                if (!$rootScope.REQUEST_ABORT_PENDING) {
                    if (success) {
                        popup.model.request_progress += popup.model.chunk.length / popup.model.total_elements * 100;
                        if (options && options.error_report) {
                            $scope.sendingResult.success += data.success;
                            if (data.error) {
                                $scope.sendingResult.error += data.error;
                            }

                            $scope.sendingResult.no_processed += data.no_processed;
                        }

                        if (options && options.price_calc) {
                            $scope.sendingResult.cost += data.cost;
                            if (data.error) {
                                $scope.sendingResult.error += data.error;
                            }
                            $scope.sendingResult.no_processed += data.no_processed;
                        }

                        if (options && options.error_log) {
                            console.info('options.error_log', $scope.sendingResult);
                            if (data.error && data.error.length > 0) {
                                $scope.sendingResult.error_log = $scope.sendingResult.error_log.concat(data.error);
                            } else if (Array.isArray(data) && data.length > 0) {
                                var hasErrors = data.filter(function (item) {
                                    return !!item.error;
                                }).map(function (item) {

                                    if (!item.error_str && !!item.error) {
                                        item.error_str = item.error;
                                    }
                                    return item;
                                });

                                if (hasErrors) {
                                    $scope.sendingResult.error_log = $scope.sendingResult.error_log.concat(hasErrors);
                                    $scope.sendingResult.error += hasErrors.length;
                                }
                            }

                        }

                        if (popup.model.users.length > 0) {
                            popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
                            post_data.users = popup.model.chunk;
                            request(post_data, handleResult);
                        } else {
                            if (!options || (options && !options.price_calc)) {
                                modal.close();
                            }

                            if (options && options.price_calc) {
                                $scope.sendingResult.priceCalculated = true;
                            }

                            if (options && options.update_user_list) {
                                $scope.getCustomers();
                            }

                            if (options && ($scope.sendingResult && $scope.sendingResult.error_log && $scope.sendingResult.error_log.length > 0 ||
                                options.error_report && !options.price_calc)
                            ) {
                                modal.close();

                                popupOperationResult($scope.sendingResult, options);
                            } else {
                                if (options && options.callbackOnSuccess) {
                                    options.callbackOnSuccess();
                                }
                            }

                        }
                    }
                } else {
                    $rootScope.REQUEST_ABORT_PENDING = false;
                }
            }

            request(post_data, handleResult);
        }

        function popupOperationResult(r, o) {
            console.log('popupOperationResult', r, o);
            $scope.modalOperationResult = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.operation_result.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.result = r;
                    popup.options = o;

                    popup.onErrosLogExport = function (format) {
                        var file_name = $rootScope.ENV.business.code + '_errors_' + moment().format('YYYY-MM-DD_HH:mm:ss');

                        switch (format) {
                            case 'XLSX':
                                alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [popup.result.error_log]);
                                break;
                            case 'XLS':
                                alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [popup.result.error_log]);
                                break;
                            case 'CSV':
                                alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [popup.result.error_log]);
                                break;
                        }
                    };

                    popup.onOk = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.$watch('account.type', function (newValue, oldValue, scope) {
            if (newValue === 'money' && !$scope.account.currency) $scope.account.currency = $rootScope.ENV.business.currency;
        });

        $rootScope.$watch('L_LIST', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = angular.copy($rootScope.L_LIST);

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (filterItem) {
                        if (filterItem.filter_list_type === 'loyalty') {
                            if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === 'pos' || filterItem.filter_list_type === 'register') {
                            if (filterItem.loyalty_id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        }
                    });
                } else {
                    $scope.data.currentFilter = getFirstActive($scope.data.filtersList);
                }
            }
        });

        $scope.$watch('data.currentFilter', function (newValue, oldValue) {
            if (newValue) {
                var l = $rootScope.ENV.filters.orders_list;
                if (l) l.filter = newValue; else l = {filter: newValue};

                $rootScope.ENV.filters.orders_list = l;

                if (l.filter.filter_list_type === 'loyalty') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.id};
                } else if (l.filter.filter_list_type === 'pos' || l.filter.filter_list_type === 'register') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.loyalty_id};
                } else if (l.filter.id === '0') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: '0'};
                }

                $rootScope.storeENV();
            }
        }, true);

        $scope.$watchGroup(['model.headerExist', 'dataImport.primary_id_type', 'dataImport.moment_format_parse_expire_date'], function (newValue, oldValue) {
            if ($scope._importPageMode == 'preview') {
                if ($scope.dataImport.imported) {
                    processData();
                }
            }
        }, true);
    }
})();
